module.exports = ".card {\n  min-height: 200px;\n}\n.card .card-body {\n  padding: 40px;\n  text-align: center;\n}\n.loading-container .text {\n  display: inline-block;\n  margin-left: 7px;\n  line-height: 5px;\n  vertical-align: text-top;\n}\n.loading-container mat-progress-spinner {\n  display: inline-block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/log/log.component.less
// module id = ./src/app/projects/project/log/log.component.less
// module chunks = main